import { ReactElement } from 'react';

type CaFlagProps = {
    width?: string;
    height?: string;
};
// eslint-disable-next-line no-empty-pattern
function CaFlag({ width = '40', height = '30' }: CaFlagProps): ReactElement {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 40 30"
            fill="none"
            stroke="yellow"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_5541_37120)">
                <g clipPath="url(#clip1_5541_37120)">
                    <path
                        d="M9.01501 -0.34082H30.9784V30.341H9.00854L9.01501 -0.34082Z"
                        fill="white"
                    />
                    <path
                        d="M-1.96338 -0.34082H9.01507V30.341H-1.96338V-0.34082ZM30.9784 -0.34082H41.9569V30.341H30.9849L30.9784 -0.34082ZM12.306 14.4887L11.4461 14.77L15.4159 18.2217C15.7198 19.0974 15.3125 19.3595 15.0539 19.8197L19.3599 19.2828L19.2564 23.5654L20.1552 23.5463L19.9547 19.2892L24.2672 19.8005C24.0021 19.2444 23.7629 18.9504 24.0086 18.0619L27.972 14.8019L27.2802 14.5463C26.7112 14.1116 27.5258 12.4624 27.6422 11.4205C27.6422 11.4205 25.334 12.2068 25.1853 11.7913L24.5905 10.6727L22.4827 12.961C22.2564 13.0186 22.1595 12.9291 22.1013 12.7373L23.0711 7.95606L21.5323 8.81259C21.403 8.87012 21.2737 8.81898 21.1961 8.67196L19.709 5.73162L18.1832 8.78702C18.0668 8.89569 17.9504 8.90847 17.8599 8.83177L16.3793 8.01998L17.2651 12.7565C17.1939 12.9482 17.0258 12.9994 16.8319 12.8971L14.8146 10.6407C14.556 11.0562 14.375 11.7338 14.0258 11.8872C13.6767 12.0342 12.5064 11.5995 11.7241 11.4397C11.9957 12.3857 12.8233 13.971 12.306 14.4887Z"
                        fill="#D52B1E"
                    />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_5541_37120">
                    <rect width="40" height="30" rx="4" fill="white" />
                </clipPath>
                <clipPath id="clip1_5541_37120">
                    <rect
                        width="41.3793"
                        height="30.6818"
                        fill="white"
                        transform="translate(-0.689697 -0.34082)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
}

export default CaFlag;
